import React, { useState, useEffect, useContext } from 'react';
import { Modal, Checkbox, Button } from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import parse from 'html-react-parser';
import HandZoom from './Bilder/Handschalter mit Lupe.png';
import ValueContext from './Context';
import './FirstVisitPopup.css';

export default function FirstVisitPopup() {
  const { locale, getText } = useContext(ValueContext);
  const [text, settext] = useState(getText());
  const [showModal, setshowModal] = useState(!localStorage.getItem('HS_Remember_me'));
  const [Checked, setChecked] = useState(false);

  function closeModal() {
    setshowModal(false);
    if (Checked) {
      localStorage.setItem('HS_Remember_me', true);
    }
  }

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <div>
      <Modal
        title={text.FirstVisitPopup.Title}
        width='70vw'
        style={{ top: 25, whiteSpace: 'pre-wrap' }}
        visible={showModal}
        onCancel={closeModal}
        footer={[
          <Checkbox checked={Checked} onChange={() => setChecked(!Checked)}>
            {text.FirstVisitPopup.DontShowAgain}
          </Checkbox>,
          <Button type='primary' onClick={closeModal} >{text.FirstVisitPopup.CloseTut}</Button>,
        ]}>
        <p>{text.FirstVisitPopup.General}</p>
        <p>
          <b>{text.FirstVisitPopup.Navi}</b>
          {text.FirstVisitPopup.NaviTextP1}
          <QuestionCircleTwoTone twoToneColor='#cdcdcd' className='QuestionMarkIcon' />
          {text.FirstVisitPopup.NaviTextP2}
        </p>
        <p>
          <b>{text.FirstVisitPopup.Over}</b>
          {text.FirstVisitPopup.OverText}
        </p>
        <p>
          <b>{text.FirstVisitPopup.Assembly}</b>
          {text.FirstVisitPopup.AssemblyText}
        </p>
        <hr />
        <p className='PopupConfig'>
          <b>{text.FirstVisitPopup.Config}</b>
          {parse(text.FirstVisitPopup.ConfigText)}
        </p>
        <p>
          <img src={HandZoom} className='FirstVisitModalHandZoom' alt='Handschalter mit Lupe' />
          {text.FirstVisitPopup.ZoomText}
        </p>
      </Modal>
    </div>
  );
}
